export default {"src":"/_next/static/media/last.4e9c207d.svg","height":278,"width":677,"blurWidth":0,"blurHeight":0};